import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import { Row, Col } from 'react-flexbox-grid'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import ArticuloStockItem from './articuloStockItem'
import DragAndDrop from '../Common/dragAndDrop'
import Checkbox from '@material-ui/core/Checkbox'
import CircularProgress from '@material-ui/core/CircularProgress'
import CurrencyFormat from 'react-currency-format'
import NumberFormat from 'react-number-format'
import CropperModal from '../CropperModal'
import MyDialog from '../Layout/myDialog'
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import Paper from '@material-ui/core/Paper';
import 'react-anything-sortable/sortable.css'
import './styles.css';
import * as Notification from '../../components/Common/notification'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';


class ArticuloTextilNuevo extends React.Component {
	over = null;
	overaux = null;

	renderButtons = () => {
		return (
			<div>
				{this.props.edicion && <Button variant="contained" className="btnSecundario" onClick={this.props.handleOnBorrarArticulo}>BORRAR</Button>}
				<Button variant="contained" className="btnSecundario" onClick={this.props.handleOnCancel}>CANCELAR</Button>
				<Button variant="contained" className="btnPrincipal" onClick={this.props.handleOnSave} disabled={!this.props.canSave}>GUARDAR</Button>

			</div>
		)
	}

	dragStart(e) {
		this.dragged = e.currentTarget;
		e.dataTransfer.effectAllowed = 'move';
		e.dataTransfer.setData('text/html', this.dragged);
	}
	dragEnd(e) {
		// update state
		var from = Number(this.dragged.dataset.id);
		var to = Number(this.over);
		if (from !== to && to !== -1 && this.over !== undefined) {
			if (this.props.canSwap === false) { return; }

			e.target.parentElement.style.borderColor = "" //le saco los bordes
			e.target.parentElement.style.borderWidth = "1px"

			this.overaux.lastChild.lastElementChild.style.borderColor = "";
			this.overaux.lastChild.lastElementChild.style.borderWidth = "1px"

			this.props.handleOnChangeOrderArticuloImagenes(from - 1, to - 1) // ya que utilizaremos los indices del array de imagenes

		}
		else {
			Notification.showError('Error al arrastrar. Intente nuevamente.')
			e.target.parentElement.style.borderColor = "" //le saco los bordes
			e.target.parentElement.style.borderWidth = "1px"
		}
	}
	dragOver(e) {
		e.preventDefault();

		if (e.target.className === 'placeholder') return;
		if (e.target.parentElement.parentElement.parentElement.dataset.id) {

			this.over = e.target.parentElement.parentElement.parentElement.dataset.id;
			this.overaux = e.target.parentElement.parentElement.parentElement;
			
			e.target.parentElement.style.borderColor = "cyan"
			e.target.parentElement.style.borderWidth = "3px"

		}
	}

	constructor(props) {
		super(props)

		this.tipoTalleInput = React.createRef();
		this.state = {

			updateTalle: false,
			selectedTypeTalle: 0,
			nuevoSubrubro: true,
			nuevoTipoTalle: true,
		}

	}



	componentWillReceiveProps(props) {

		if (props.articulo.stock !== undefined && props.tipotalle !== undefined && this.state.updateTalle === true) {

			this.setState({
				updateTalle: false

			})
		}
	}


	handleOnChangeArticulo = (e) => {

		this.props.handleArticuloNombre(e.target.value)
	}

	handleOnChangePrecio = (e) => {
		if (Number.isNaN(e.floatValue)) {
			this.props.handleArticuloPrecio(e.value)
		}
		else { this.props.handleArticuloPrecio(e.floatValue) }
	}

	handleStockClick = () => {
		this.setState({
			updateTalle: true
		})
		this.props.handleAddStockItem(this.props.articulo.idTipoTalle)
	};

	handleChangeTipotalle = (e) => {
		this.setState({
			nuevoTipoTalle: false
		})
		this.props.handleArticuloIdTipoTalle(e.target.value)
	}

	handleChangeSubrubro = (e) => {
		this.setState({
			nuevoSubrubro: false
		})
		this.props.handleArticuloIdSubrubro(e.target.value)
	}

	handleSelectedTypeTalles = (selectedTypeTalle) => {
		this.setState({
			selectedTypeTalle: selectedTypeTalle
		})
	}

	handleArticuloStockTipo = (idTipo, index) => {
		this.props.handleArticuloStockTipo(idTipo, index)
	}

	render() {
		return (

			<div className='articuloCreateEdit'>

				<div>
					{/* Primer encabezado: Combos */}

					<TitleBar
						title={this.props.catalogoNombre !== undefined && this.props.edicion == false ?
							this.props.catalogoNombre + " " + "-" + " " + 'Nuevo Artículo' :
							this.props.catalogo !== undefined && this.props.edicion == true ?
								(this.props.catalogo.idCatalogo != "0" ? this.props.catalogo.nombre + " - " : ""	) + 'Edición Artículo' :
								'Nuevo Articulo'}
						type='createArticulo'
						showSearch={false}
						buttons={this.renderButtons()}

					/>

					{/*por si borramos el articulo */}
					{this.props.showBorrarArticuloDialog ?
						<MyDialog cuerpo={'Esta por borrar el artículo ' + this.props.articulo.nombre} botonConfirmar={'BORRAR'} handleOnConfirmar={(e) => this.props.handleOnBorrarConfirmed(this.props.articuloEdicion.idArticulo, this.props.catalogo.idCatalogo)} handleOnCancelar={this.props.handleOnCancelarBorrarArticulo} />
						:
						''
					}

					<Row style={{ backgroundColor: 'white' }}>

						<Col md={6}>
							<TextField
								id="subrubro"
								select
								required
								error={this.props.errorDescription.errorSubrubro !== undefined ? true : false}
								helperText={this.props.errorDescription.errorSubrubro !== undefined ? this.props.errorDescription.errorSubrubro : ''}
								label="Subrubro"
								value={this.props.edicion === false && this.state.nuevoSubrubro === true ? '' : this.props.articulo.idSubrubro}
								onChange={this.handleChangeSubrubro}
								style={{ width: '100%' }}
								margin="normal">
								{this.props.subrubros.map(item => (
									<MenuItem key={item.idSubrubro} value={item.idSubrubro}>
										{item.nombre}
									</MenuItem>
								))}
							</TextField>
						</Col>

						<Col md={6} >
							<TextField
								required
								id="articulo"
								label="Articulo"
								error={this.props.errorDescription.errorNombre !== undefined || this.props.errorDescription.errorNombre === '' ? true : false}
								helperText={this.props.errorDescription.errorNombre !== undefined || this.props.errorDescription.errorNombre === '' ? this.props.errorDescription.errorNombre : ''}
								value={this.props.articulo.nombre}
								style={{ width: '100%' }}
								margin="normal"
								onChange={this.handleOnChangeArticulo}>
							</TextField>
						</Col>

						<Col md={6} >
							<TextField
								id="codigoInterno"
								label="Codigo interno"
								value={this.props.articulo.codigoInterno}
								style={{ width: '100%' }}
								margin="normal"
								onChange={this.props.handleOnChangeCodigoInterno}
								onKeyPress={(e) => {
									if (e.key === 'Enter') {
										let txt = this.tipoTalleInput
										txt.current.focus();
									}
								}}>
							</TextField>

						</Col>

						<Col md={6} >
							<CurrencyFormat
								required
								className='currencyInput'
								customInput={TextField}
								error={this.props.errorDescription.errorPrecio !== undefined || this.props.errorDescription.errorPrecio === '' ? true : false}
								helperText={this.props.errorDescription.errorPrecio !== undefined || this.props.errorDescription.errorPrecio === '' ? this.props.errorDescription.errorPrecio : ''}
								label="Precio"
								style={{ width: '100%', marginTop: '15px', textAlign: 'right' }}
								decimalScale={2}
								fixedDecimalScale={true}
								allowNegative={false}
								decimalSeparator=","
								thousandSeparator="."
								prefix={'$'}
								value={this.props.articulo.precio}
								onValueChange={this.handleOnChangePrecio} />

						</Col>

						<Col md={6} >
							<TextField
								id="articulo"
								select
								required
								label="Tipo Talle"
								error={this.props.errorDescription.errorTipoTalle !== undefined ? true : false}
								helperText={this.props.errorDescription.errorTipoTalle !== undefined ? this.props.errorDescription.errorTipoTalle : ''}
								value={this.props.edicion === false && this.state.nuevoTipoTalle === true ? '' : this.props.articulo.idTipoTalle}
								onChange={this.handleChangeTipotalle}
								style={{ width: '100%' }}
								margin="normal"
								inputRef={this.tipoTalleInput}>
								{this.props.tipotalle.map(item => (
									<MenuItem key={item.idTipoTalle} value={item.idTipoTalle}>
										{item.nombre}
									</MenuItem>
								))}
							</TextField>
						</Col>
					</Row>
				</div>


				{/* Segundo encabezado: Stock */}

				<Row className='stockItemRow'>
					<Col md={12} >
						<Button variant="contained" className="btnPrincipal" onClick={this.handleStockClick} style={{ padding: '10px', marginTop: '10px', marginBotton: '10px', display: 'flex' }}>AGREGAR STOCK</Button>
					</Col>

					<Col md={12} >
						<Divider style={{ marginTop: '10px' }} inset={true} variant="inset" />
					</Col>
				</Row>

				{this.props.articulo.stock.length > 0 ? this.props.articulo.stock.map((c, i) => {

					return (
						<ArticuloStockItem
							talle={c.talle}
							index={i}
							key={i}
							handleStockDelete={this.props.handleStockDelete}
							handleSelectedTypeTalles={this.handleSelectedTypeTalles}
							handleArticuloStockTipo={this.handleArticuloStockTipo}
							handleStockColor={this.props.handleStockColor}
							handleStockImagen={this.props.handleStockImagen}
							onChangeCantidad={this.props.onChangeCantidad}
							articulo={this.props.articulo}
							errorDescription={this.props.errorDescription}
							articuloEdicion={this.props.articuloEdicion}
							edicion={this.props.edicion}
						/>)

				}) : ''}


				{/* Tercer encabezado: Imagenes */}

				<DragAndDrop
					data-id='-1'
					accept='image/jpeg, image/png'
					message='Arrastra las imágenes o'
					handleOnDrop={this.props.handleOnDropFile}
					multiple={true} />

				<Paper onDragOver={this.dragOver.bind(this)}>
					<Row style={{ backgroundColor: 'white' }}>
						{this.props.articulo.imgSrc.map((c, i) => {
							return (
								<Col className='imagenArticuloContainer' md={3} data-id={c.orden} draggable='true' onDragEnd={this.dragEnd.bind(this)} onDragStart={this.dragStart.bind(this)} >
									<div>
										<Checkbox className='check' onChange={(e) => this.props.handleCheckboxChange({ i }, e)} value={c.selected} checked={c.selected} />
										<div>
											{/*<IconButton
												className='iconMenu'
												aria-label="More"
												aria-owns={'long-menu'}
												aria-haspopup="true"
												onClick={(event) => this.handleClick(event,i)}
											>
												<MoreVertIcon />
											</IconButton>
											<Menu
												id="long-menu"
												anchorEl={anchorEl}
												open={open}
												onClose={this.handleClose}
												PaperProps={{
													style: {
														maxHeight: ITEM_HEIGHT * 4.5,
														width: 200,
													},
												}}
											>
												<MenuItem key={i} onClick={this.handleClose}>
													Eliminar
												</MenuItem>
											</Menu>*/}
											<PopupState variant="popover" popupId="demo-popup-menu">
												{popupState => (
													<React.Fragment>
														<IconButton
															className='iconMenu'
															{...bindTrigger(popupState)}
														>
															<MoreVertIcon />
														</IconButton>
														<Menu {...bindMenu(popupState)}>
															<MenuItem onClick={()=> {this.props.handleEliminarImagenArticulo(i)}}>Eliminar</MenuItem>
														</Menu>
													</React.Fragment>
												)}
											</PopupState>
										</div>
										<div className='imageContainer'>
											{c !== undefined && (c.imagen !== undefined || c.idArticuloImagenes === 0) ?
												<img onClick={() => { this.props.handleOnOpenCropperModal(c) }} src={c.pathImagen !== undefined ? c.pathImagen : `data:image/ief;base64,${c.imagen}`} className='imagenArticulo' />
												:
												<div>
													<CircularProgress />
												</div>
											}
										</div>
									</div>
								</Col>)
						})
						}
					</Row>
				</Paper>

				{/* CROPPER PARA IMAGENES DE ITEM DE STOCK */}
				{this.props.openModalImagenTalleColor &&
					<CropperModal
						src={this.props.imagenTalleColor}
						handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
						handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
						open={this.props.openModalImagenTalleColor}
					/>
				}

				{/* CROPPER PARA IMAGENES ARTÍCULO */}
				{this.props.openModalImagen &&
					<CropperModal
						ratio={2 / 3}
						src={this.props.imagenOriginal}
						handleOnCloseCropperModal={this.props.handleOnCloseCropperModal}
						handleOnSaveImagenCortada={this.props.handleOnSaveImagenCortada}
						open={this.props.openModalImagen}
						modalArticulo={true}
					/>
				}

			</div>
		)

	}


}

ArticuloTextilNuevo.propTypes = {
	imagenOriginal: PropTypes.object.isRequired,
	imagenTalleColor: PropTypes.object.isRequired,
	openModalImagen: PropTypes.object.isRequired,
	openModalImagenTalleColor: PropTypes.object.isRequired,
	handleOnCloseCropperModal: PropTypes.func.isRequired,
	handleOnOpenCropperModal: PropTypes.func.isRequired,
	handleOnSaveImagenCortada: PropTypes.func.isRequired,

	handleClickMenuImagenArticulo: PropTypes.func.isRequired,
	handleCloseMenuImagenArticulo: PropTypes.func.isRequired,
	handleEliminarImagenArticulo: PropTypes.func.isRequired,
};

ArticuloTextilNuevo.defaultProps = {
	tipotalle: [],
	subrubros: [],
	infoCatalogo: []
}

export default ArticuloTextilNuevo